/**
 * Eigenbau: Getönte Fläche als Kante — der Entwurf kennt keine Rahmen.
 *
 * Wo andere Systeme einen Rahmen ziehen, senkt der Entwurf die Fläche: Listen,
 * Leerzustände und Innenbereiche liegen auf `--wisch`, eine Stufe unter dem
 * Papier. Das Haus hat den Schritt schon einmal gemacht — `Leerzustand` trägt
 * seit der Abstimmung „randlose Karten" eine vertiefte Fläche statt eines
 * gestrichelten Rahmens. Hier wird daraus die Regel.
 *
 * Kein Tremor-Gegenstück: `Card` bringt Rundung, Polsterung und im Original
 * einen Ring mit. Diese Fläche bringt nur die Tönung.
 *
 * Paket 19 hält beide Sätze fest, die hier gelten: „Leerzustände als getönte
 * Fläche, **nie** mit gestricheltem Rahmen" und „Innerhalb einer Karte nie ein
 * zweiter Rahmen".
 */

import type { ReactNode } from "react";
import { cx } from "@/lib/utils";

export function Flaeche({
  children,
  polster = true,
  className,
}: {
  children: ReactNode;
  /** Aus, wenn die Fläche eine Liste trägt — die Zeilen polstern selbst. */
  polster?: boolean;
  className?: string;
}) {
  return (
    <div className={cx("bg-wisch", polster && "p-6", className)}>
      {children}
    </div>
  );
}
